import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchGalleryData } from '../../features/Gallery/Gallery'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/opacity.css'
import { useTranslation } from 'react-i18next'
import ShowMultiImageModal from '../Modal/ShowMultiImageModal'

export default function AllGalleryPage() {
  const dispatch = useDispatch()
  const [perPage, setPerPage] = useState(12)
  const [lightboxIndex, setLightboxIndex] = useState(null)
  const { galleries = [] } = useSelector((state) => state.gallery)

  // Flatten all gallery images into a single list
  const imageList = useMemo(() => {
    return galleries.reduce((acc, gallery, gIdx) => {
      (Array.isArray(gallery.images) ? gallery.images : []).forEach((img, iIdx) => {
        acc.push({
          src: process.env.REACT_APP_IMG_URL + img,
          title: gallery.title,
          date: gallery.published_at,
          galleryIndex: gIdx,
          imageIndex: iIdx,
        })
      })
      return acc
    }, [])
  }, [galleries])
  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 100 >=
      document.documentElement.offsetHeight &&
      galleries.length >= perPage
    ) {
      setPerPage((prev) => prev + 8)
    }
  }, [galleries.length, perPage])

  // Keyboard handlers
  const handleKeyDown = useCallback(
    (e) => {
      if (lightboxIndex !== null) {
        if (e.key === 'ArrowRight') isRTL ? navigateLightbox('prev') : navigateLightbox('next')
        if (e.key === 'ArrowLeft') isRTL ? navigateLightbox('next') : navigateLightbox('prev')
        if (e.key === 'Escape') closeLightbox()
      }
    },
    [lightboxIndex, imageList.length]
  )

  // Fetch
  useEffect(() => {
    dispatch(fetchGalleryData(perPage))
  }, [dispatch, perPage])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  // Open & close lightbox
  const openLightbox = (idx) => {
    setLightboxIndex(idx)
    document.body.style.overflow = 'hidden'
  }
  const closeLightbox = () => {
    setLightboxIndex(null)
    document.body.style.overflow = 'auto'
  }

  // Next / Prev
  const navigateLightbox = (direction) => {
    if (lightboxIndex === null) return
    const total = imageList.length
    const next =
      direction === 'next'
        ? (lightboxIndex + 1) % total
        : (lightboxIndex - 1 + total) % total
    setLightboxIndex(next)
  }
  const {i18n} = useTranslation()
  const isRTL = i18n.language === 'ar' || i18n.language === 'ckb';
  return (
    <div className="w-11/12 mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {imageList.map((img, idx) => (
          <div
            key={`img-${idx}`}
            className="group relative h-[250px] cursor-pointer overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            onClick={() => openLightbox(idx)}
          >
            <LazyLoadImage
              src={img.src}
              alt={img.title || `Image ${idx + 1}`}
              effect="opacity"
              className="h-full w-full object-cover transform transition-transform duration-300 group-hover:scale-105"
              placeholderSrc="/placeholder-image.jpg"
              wrapperClassName="h-full w-full"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-teal-700/40 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
              <p className="text-white font-medium text-sm">
                {new Date(img.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
          </div>
        ))}
      </div>
        <ShowMultiImageModal
        images={imageList}
        isPrefix={true}
        onClose={closeLightbox}
        isOpen={lightboxIndex !== null}
        startIndex={lightboxIndex}
        isRTL={isRTL}
      />
     
    </div>
  )
}

// export default AllGalleryPage